module.exports = __webpack_public_path__ + "static/media/background.3104ba3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.jpg
// module id = 189
// module chunks = 0